const NAMED_HTML_ENTITIES: Record<string, string> = {
  nbsp: " ",
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
};

const decodeNumericEntity = (value: number): string | null => {
  if (!Number.isFinite(value) || value < 0 || value > 0x10ffff) {
    return null;
  }

  try {
    return String.fromCodePoint(value);
  } catch {
    return null;
  }
};

const stripHtmlEntities = (text: string): string => {
  let result = text.replace(
    /&#x([0-9a-f]+);/gi,
    (match, hex: string) => decodeNumericEntity(parseInt(hex, 16)) ?? match,
  );

  result = result.replace(
    /&#(\d+);/g,
    (match, decimal: string) =>
      decodeNumericEntity(parseInt(decimal, 10)) ?? match,
  );

  result = result.replace(/&([a-z]+);/gi, (match, name: string) => {
    const key = name.toLowerCase();
    if (key in NAMED_HTML_ENTITIES) {
      return NAMED_HTML_ENTITIES[key];
    }
    return match;
  });

  result = result.replace(/\u00a0/g, " ");

  return result;
};

export default stripHtmlEntities;
